import { IPatientsListFilters } from '~/services/api/patients/types';
import { PatientStatus } from '~/services/api/enums';
import { getCurrentMonthFirstDayDate, setEndOfDay } from '~/utils/date';
import { ICurrentUser } from '~/services/api/auth/types';

export const getDefaultValues = (): IPatientsListFilters => ({
  startDate: getCurrentMonthFirstDayDate(),
  endDate: setEndOfDay(new Date()),
  programId: '',
  patientSearchTerm: '',
  healthCareManagerIds: [],
  status: PatientStatus.Active,
  isHomeHealthCare: '',
});

export const getInitialValues = (currentUser: ICurrentUser): IPatientsListFilters => {
  const patientsFiltersJson = localStorage.getItem('patientsFilters');
  const patientsFilters = patientsFiltersJson
    ? (JSON.parse(patientsFiltersJson) as IPatientsListFilters)
    : {};

  return {
    ...getDefaultValues(),
    ...patientsFilters,
    isHomeHealthCare: currentUser.isHomeHealthCareOnlyEnabled
      ? ''
      : patientsFilters.isHomeHealthCare,
  };
};

export default {};
